import { render } from "./Botoes.vue?vue&type=template&id=a51108e4&scoped=true"
import script from "./Botoes.vue?vue&type=script&lang=js"
export * from "./Botoes.vue?vue&type=script&lang=js"

import "./Botoes.vue?vue&type=style&index=0&id=a51108e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a51108e4"]])

export default __exports__